import { Outlet, createFileRoute } from "@tanstack/react-router"

import { requirePermissionRouteAccess } from "@/features/authz/require-permission-route-access"

export const Route = createFileRoute("/dashboard/settings/access-control")({
	component: Outlet,
	beforeLoad: async ({ context }) => {
		await requirePermissionRouteAccess(context.queryClient, ["access.roles.read", "access.assignments.read"])
	},
})
